import { FormattedMessage } from 'react-intl';

import type { SchedulerCalendarProperty } from '@/store/targetAccumulator/utils.ts';

const LABELS: (ccy: string | undefined) => Record<SchedulerCalendarProperty, React.ReactNode> = (ccy) => ({
  amount: <FormattedMessage id="accumulator.scheduler.calendar.notional" values={{ ccy }} />,
  leverageAmount: <FormattedMessage id="accumulator.scheduler.calendar.leverageAmount" values={{ ccy }} />,
  fixingDate: <FormattedMessage id="accumulator.scheduler.calendar.fixingDate" />,
  paymentDate: <FormattedMessage id="accumulator.scheduler.calendar.paymentDate" />,
  strike: <FormattedMessage id="accumulator.scheduler.calendar.strike" />,
  PIVOT: <FormattedMessage id="accumulator.scheduler.calendar.pivot" />,
  strikeUp: <FormattedMessage id="accumulator.scheduler.calendar.strikeUp" />,
  strikeDown: <FormattedMessage id="accumulator.scheduler.calendar.strikeDown" />,
  ekiDown: <FormattedMessage id="accumulator.scheduler.calendar.ekiDown" />,
  ekiUp: <FormattedMessage id="accumulator.scheduler.calendar.ekiUp" />,
  EKI: <FormattedMessage id="accumulator.scheduler.calendar.EKI" />,
  deleteIcon: null,
});

const PropertyHeader = ({
  property,
  currency,
}: {
  property: SchedulerCalendarProperty;
  currency: string | undefined;
}) => {
  const label = LABELS(currency)[property];
  return label ? <div>{label}</div> : null;
};

export default PropertyHeader;
